import ICON_MAPPING from '../../assets/what3words/sprites-output/sprites-info.json';
import alertsSprites from '../../assets/what3words/sprites-output/sprites_2x.png';

export const MARKER_SIZES = {
  sizeScale: 60, // this is the factor to scale the icon.
  sizeMinPixels: 38, // when zoomed out, the max height of the icon.
  sizeMaxPixels: 30, // when zoomed in, the max height of the icon.
};

export const getW3WIconProps = () => ({
  iconAtlas: alertsSprites,
  iconMapping: ICON_MAPPING,
  sizeUnits: 'meters',
  visible: true,
  pickable: true,
  highlightColor: [255, 255, 255, 60],
  getIcon: () => 'what3words_selected',
  getPosition: d => [d?.coordinates?.lng, d?.coordinates?.lat],
  getColor: [255, 255, 255, 255],
  ...MARKER_SIZES,
});
